import { Select, SelectProps } from 'antd';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useMemo } from 'react';

const langConfigs = [
  ['阿尔巴尼亚语-Shqip', 'Albanian-Shqip', 'sq'],
  ['阿拉伯语-العربية', 'Arabic-العربية', 'ar'],
  ['阿姆哈拉语-አማርኛ', 'Amharic-አማርኛ', 'am'],
  ['阿萨姆语-অসমীয়া', 'Assamese-অসমীয়া', 'as'],
  ['阿塞拜疆语-Azərbaycanca', 'Azerbaijani-Azərbaycanca', 'az'],
  ['埃维语-Eʋegbe', 'Ewe-Eʋegbe', 'ee'],
  ['艾马拉语-Aymar Aru', 'Aymara-Aymar Aru', 'ay'],
  ['爱尔兰语-Gaeilge', 'Irish-Gaeilge', 'ga'],
  ['爱沙尼亚语-Eesti', 'Estonian-Eesti', 'et'],
  ['奥利亚语-ଓଡ଼ିଆ', 'Odia-ଓଡ଼ିଆ', 'or'],
  ['奥罗莫语-Afaan Oromoo', 'Oromo-Afaan Oromoo', 'om'],
  ['巴斯克语-Euskara', 'Basque-Euskara', 'eu'],
  ['白俄罗斯语-Беларуская', 'Belarusian-Беларуская', 'be'],
  ['班巴拉语-Bamanankan', 'Bambara-Bamanankan', 'bm'],
  ['保加利亚语-Български', 'Bulgarian-Български', 'bg'],
  ['冰岛语-Íslenska', 'Icelandic-Íslenska', 'is'],
  ['波兰语-Polski', 'Polish-Polski', 'pl'],
  ['波斯尼亚语-Bosanski', 'Bosnian-Bosanski', 'bs'],
  ['波斯语-فارسی', 'Persian-فارسی', 'fa'],
  ['博杰普尔语-भोजपुरी', 'Bhojpuri-भोजपुरी', 'bho'],
  ['布尔语（南非荷兰语）-Afrikaans', 'Afrikaans-Afrikaans', 'af'],
  ['鞑靼语-Татарча', 'Tatar-Татарча', 'tt'],
  ['丹麦语-Dansk', 'Danish-Dansk', 'da'],
  ['德语-Deutsch', 'German-Deutsch', 'de'],
  ['迪维希语-ދިވެހި', 'Divehi-ދިވެހި', 'dv'],
  ['蒂格尼亚语-ትግርኛ', 'Tigrinya-ትግርኛ', 'ti'],
  ['多格来语-डोगरी', 'Dogri-डोगरी', 'doi'],
  ['俄语-Русский', 'Russian-Русский', 'ru'],
  ['法罗语-Føroyskt', 'Faroese-Føroyskt', 'fo'],
  ['法语-Français', 'French-Français', 'fr'],
  ['梵语-संस्कृतम्', 'Sanskrit-संस्कृतम्', 'sa'],
  ['菲律宾语（塔加洛语）-Tagalog', 'Tagalog-Tagalog', 'tl'],
  ['芬兰语-Suomi', 'Finnish-Suomi', 'fi'],
  ['弗里西语-Frysk', 'Frisian-Frysk', 'fy'],
  ['高棉语-ភាសាខ្មែរ', 'Khmer-ភាសាខ្មែរ', 'km'],
  ['格鲁吉亚语-ქართული', 'Georgian-ქართული', 'ka'],
  ['贡根语-कोंकणी', 'Konkani-कोंकणी', 'gom'],
  ['古吉拉特语-ગુજરાતી', 'Gujarati-ગુજરાતી', 'gu'],
  ["瓜拉尼语-Avañe'ẽ", "Guaraní-Avañe'ẽ", 'gn'],
  ['哈萨克语-Қазақ Тілі', 'Kazakh-Қазақ Тілі', 'kk'],
  ['海地克里奥尔语-Kreyòl Ayisyen', 'Haitian Creole-Kreyòl Ayisyen', 'ht'],
  ['韩语-한국어', 'Korean-한국어', 'ko'],
  ['豪萨语-Hausa', 'Hausa-Hausa', 'ha'],
  ['荷兰语-Nederlands', 'Dutch-Nederlands', 'nl'],
  ['吉尔吉斯语-Кыргызча', 'Kyrgyz-Кыргызча', 'ky'],
  ['加利西亚语-Galego', 'Galician-Galego', 'gl'],
  ['加泰罗尼亚语-Català', 'Catalan-Català', 'ca'],
  ['捷克语-Čeština', 'Czech-Čeština', 'cs'],
  ['卡纳达语-ಕನ್ನಡ', 'Kannada-ಕನ್ನಡ', 'kn'],
  ['卡努里语-Kanuri', 'Kanuri-Kanuri', 'kr'],
  ['科西嘉语-Corsu', 'Corsican-Corsu', 'co'],
  ['克罗地亚语-Hrvatski', 'Croatian-Hrvatski', 'hr'],
  ['克丘亚语-Runa Simi', 'Quechua-Runa Simi', 'qu'],
  ['克什米尔语-कॉशुर / کٲشُر', 'Kashmiri-कॉशुर / کٲشُر', 'ks'],
  ['库尔德语（库尔曼吉语）-Kurdî', 'Kurmanji Kurdish-Kurdî', 'ku'],
  ['库尔德语（索拉尼）-کوردی', 'Sorani Kurdish-کوردی', 'ckb'],
  ['拉丁语-Latina', 'Latin-Latina', 'la'],
  ['拉脱维亚语-Latviešu', 'Latvian-Latviešu', 'lv'],
  ['老挝语-ພາສາລາວ', 'Lao-ພາສາລາວ', 'lo'],
  ['立陶宛语-Lietuvių', 'Lithuanian-Lietuvių', 'lt'],
  ['林格拉语-Lingála', 'Lingala-Lingála', 'ln'],
  ['隆迪语-Kirundi', 'Rundi-Kirundi', 'rn'],
  ['卢干达语-Luganda', 'Ganda-Luganda', 'lg'],
  ['卢森堡语-Lëtzebuergesch', 'Luxembourgish-Lëtzebuergesch', 'lb'],
  ['卢旺达语-Ikinyarwanda', 'Kinyarwanda-Ikinyarwanda', 'rw'],
  ['罗马尼亚语-Română', 'Romanian-Română', 'ro'],
  ['马尔加什语-Malagasy', 'Malagasy-Malagasy', 'mg'],
  ['马耳他语-Malti', 'Maltese-Malti', 'mt'],
  ['马拉地语-मराठी', 'Marathi-मराठी', 'mr'],
  ['马拉雅拉姆语-മലയാളം', 'Malayalam-മലയാളം', 'ml'],
  ['马来语-Bahasa Melayu', 'Malay-Bahasa Melayu', 'ms'],
  ['马其顿语-Македонски', 'Macedonian-Македонски', 'mk'],
  ['迈蒂利语-मैथिली', 'Maithili-मैथिली', 'mai'],
  ['毛利语-Māori', 'Māori-Māori', 'mi'],
  ['梅泰语（曼尼普尔语）-ꯃꯤꯇꯩꯂꯣꯟ', 'Meiteilon-ꯃꯤꯇꯩꯂꯣꯟ', 'mni'],
  ['蒙古语-Монгол', 'Mongolian-Монгол', 'mn'],
  ['孟加拉语-বাংলা', 'Bengali-বাংলা', 'bn'],
  ['米佐语-Mizo ṭawng', 'Mizo-Mizo ṭawng', 'lus'],
  ['缅甸语-မြန်မာစာ', 'Burmese-မြန်မာစာ', 'my'],
  ['苗语-Hmoob', 'Hmong-Hmoob', 'hmn'],
  ['南非科萨语-isiXhosa', 'Xhosa-isiXhosa', 'xh'],
  ['南非祖鲁语-isiZulu', 'Zulu-isiZulu', 'zu'],
  ['尼泊尔语-नेपाली', 'Nepali-नेपाली', 'ne'],
  ['挪威布克莫尔语-Bokmål', 'Norwegian Bokmål-Bokmål', 'nb'],
  ['挪威尼诺斯克语-Nynorsk', 'Norwegian Nynorsk-Nynorsk', 'nn'],
  ['挪威语-Norsk', 'Norwegian-Norsk', 'no'],
  ['旁遮普语-ਪੰਜਾਬੀ', 'Punjabi-ਪੰਜਾਬੀ', 'pa'],
  ['葡萄牙语-Português', 'Portuguese-Português', 'pt'],
  ['普什图语-پښto', 'Pashto-پښto', 'ps'],
  ['齐切瓦语-Chichewa', 'Chichewa-Chichewa', 'ny'],
  ['契维语-Akan', 'Akan-Akan', 'ak'],
  ['日语-日本語', 'Japanese-日本語', 'ja'],
  ['瑞典语-Svenska', 'Swedish-Svenska', 'sv'],
  ['萨摩亚语-Gagana Samoa', 'Samoan-Gagana Samoa', 'sm'],
  [
    '塞尔维亚-克罗地亚语-Srpskohrvatski / Српскохрватски',
    'Serbo-Croatian-Srpskohrvatski / Српскохрватски',
    'sh',
  ],
  ['塞尔维亚语-Српски', 'Serbian-Српски', 'sr'],
  ['塞佩蒂语-Sepedi', 'Northern Sotho-Sepedi', 'nso'],
  ['塞索托语-Sesotho', 'Southern Sotho-Sesotho', 'st'],
  ['僧伽罗语-සිංහල', 'Sinhala-සිංහල', 'si'],
  ['世界语-Esperanto', 'Esperanto-Esperanto', 'eo'],
  ['斯洛伐克语-Slovenčina', 'Slovak-Slovenčina', 'sk'],
  ['斯洛文尼亚语-Slovenščina', 'Slovenian-Slovenščina', 'sl'],
  ['斯瓦蒂语-SiSwati', 'Swati-SiSwati', 'ss'],
  ['斯瓦希里语-Kiswahili', 'Swahili-Kiswahili', 'sw'],
  ['苏格兰盖尔语-Gàidhlig', 'Scottish Gaelic-Gàidhlig', 'gd'],
  ['索马里语-Soomaali', 'Somali-Soomaali', 'so'],
  ['塔吉克语-Тоҷикӣ', 'Tajik-Тоҷикӣ', 'tg'],
  ['泰卢固语-తెలుగు', 'Telugu-తెలుగు', 'te'],
  ['泰米尔语-தமிழ்', 'Tamil-தமிழ்', 'ta'],
  ['泰语-ไทย', 'Thai-ไทย', 'th'],
  ['土耳其语-Türkçe', 'Turkish-Türkçe', 'tr'],
  ['土库曼语-Türkmençe', 'Turkmen-Türkmençe', 'tk'],
  ['威尔士语-Cymraeg', 'Welsh-Cymraeg', 'cy'],
  ['维吾尔语-ئۇيغۇرچە', 'Uyghur-ئۇيغۇرچە', 'ug'],
  ['文达语-Tshivenḓa', 'Venda-Tshivenḓa', 've'],
  ['乌尔都语-،اردو،', 'Urdu-،اردو،', 'ur'],
  ['乌克兰语-Українська', 'Ukrainian-Українська', 'uk'],
  ['乌兹别克语-O‘zbek', 'Uzbek-O‘zbek', 'uz'],
  ['西班牙语-Español', 'Spanish-Español', 'es'],
  ['希伯来语-עברית', 'Hebrew-עברית', 'he'],
  ['希腊语-Ελληνικά', 'Greek-Ελληνικά', 'el'],
  ['夏威夷语-ʻŌlelo Hawaiʻi', 'Hawaiian-ʻŌlelo Hawaiʻi', 'haw'],
  ['匈牙利语-Magyar', 'Hungarian-Magyar', 'hu'],
  ['修纳语-chiShona', 'Shona-chiShona', 'sn'],
  ['宿务语-Binisaya', 'Cebuano-Binisaya', 'ceb'],
  ['亚美尼亚语-Հայերեն', 'Armenian-Հայերեն', 'hy'],
  ['伊博语-Igbo', 'Igbo-Igbo', 'ig'],
  ['伊洛卡诺语-Ilokano', 'Ilocano-Ilokano', 'ilo'],
  ['伊努克蒂图特语-ᐃᓄᒃᑎᑐᑦ', 'Inuktitut-ᐃᓄᒃᑎᑐᑦ', 'iu'],
  ['意大利语-Italiano', 'Italian-Italiano', 'it'],
  ['意第绪语-ייִדיש', 'Yiddish-ייִדיש', 'yi'],
  ['印地语-हिन्दी', 'Hindi-हिन्दी', 'hi'],
  ['印尼巽他语-Basa Sunda', 'Sundanese-Basa Sunda', 'su'],
  ['印尼语-Bahasa Indonesia', 'Indonesian-Bahasa Indonesia', 'id'],
  ['印尼爪哇语-Basa Jawa', 'Javanese-Basa Jawa', 'jv'],
  ['英语-English', 'English-English', 'en-US'],
  ['约鲁巴语-Yorùbá', 'Yoruba-Yorùbá', 'yo'],
  ['越南语-Tiếng Việt', 'Vietnamese-Tiếng Việt', 'vi'],
  ['扎扎其语-Zazakî', 'Zaza-Zazakî', 'zza'],
  ['中文（繁体）-中文', 'Chinese (Traditional)-中文', 'zh-TW'],
  ['中文（简体）-中文', 'Chinese (Simplified)-中文', 'zh-CN'],
  ['宗加语-Xitsonga', 'Tsonga-Xitsonga', 'ts'],
];

function FacebookLangSelect(props: SelectProps) {
  const systemLang = useSystemLanguageValue();

  const options = useMemo(() => {
    return langConfigs.map(([cn, en, value]) => {
      return {
        value,
        label: systemLang === 'zh-CN' ? cn : en,
      };
    });
  }, [systemLang]);

  return (
    <Select
      style={{ minWidth: 120 }}
      showSearch
      dropdownMatchSelectWidth={false}
      optionFilterProp="label"
      options={options}
      {...props}
    />
  );
}

export default FacebookLangSelect;
